module.exports = __webpack_public_path__ + "static/img/bg.dc07dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 3